import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { cloneDeep } from "lodash";
import { Responsive } from "Components/ReactGridLayout";
import { connect } from "react-redux";
import classNames from "classnames";
import {
    setLayouts,
    setAppGroupData,
    setDroppedAppGroupItem,
    setGroupDragable,
    updateGroupList,
    setDraggingItems,
    setUpdateLayout,
    updateEditSiderStatus,
    setWorkbenchConfig,
    updateAppProperties,
} from "Store/GridLayout/action";
import { setLinkageData } from "Store/appStore/action";
import { getCurrentLangText, getCurrentLangIndex } from "Pub/js/getMulti";
import platform from "Pub/js/platform";
const { NCPopconfirm } = platform.base;
const { PubSub, toast } = platform;
import { generateLayout, getAllCollisions } from "./methods";
import { GridLayoutAction } from "./action";
import {
    checkApp,
    COMPACT_APP_DEFAULT_SIZE,
    APP_DEFAULT_SIZE,
    PUB_WIDGET_APPCODES,
    genRandomKey,
    genNameNum,
    calcDraggingItemsPos,
    processGroupItems,
    createEmptyExternalLink,
    getScale,
    getGridRowHeight,
    getPublicData,
    DragTypes,
} from "../utilService";
import GridItem from "./GridItem";
import SideBox from "./SideBox";
import GlobalSide from "./GlobalSide";
import LinkageIcons from "Components/LinkageIcons";
import { getPartsPk, langCheck } from "Pub/js/utils";
const ResponsiveGridLayout = Responsive;
const DROPPING_ELEM = "__dropping-elem__";
function Grid(props) {
    const { apps, size, margin, col, editable, groupId, gridContainerPadding, layoutContainerStyle = {} } = props;
    const containerPadding = gridContainerPadding;
    const gridRef = useRef();
    let collideItem = useRef().current; //碰撞元素
    const gridLayout = new GridLayoutAction({
        layouts: props.apps,
        groupIndex: props.groupIndex,
        setLayouts: props.setLayouts,
    });
    const layouts = generateLayout(apps, col).lg;
    const [rowHeight, setRowHeight] = useState(getGridRowHeight(margin)); //默认卡片高度
    const [dropCompleteFlag, setDropCompleteFlag] = useState(false); //从左侧往右拖应用标示
    const [isScale, setScale] = useState(false); //设置缩放比例
    const [updated, updateLayout] = useState(false); //更新布局信息到store
    const [removePlaceholder, setRemovePlaceholder] = useState(false); //移除placeholder
    const [isMount, setMount] = useState(false); //是否重新挂载
    const [sidebox, setSidebox] = useState({ show: false, app: null, side: null }); // sidebox
    useEffect(() => {
        if (size.width) {
            setDragPreviewSize(); // 把列宽存到window上给拖拽预览使用
        }
    }, [size]);

    useEffect(() => {
        const autoDragPubsub = PubSub.subscribe("AutomaticTowing", (action, groupIndex) => { // 自动化模拟拖拽
            if (groupIndex === props.groupIndex) {
                handleDrop([], { x: 0, y: 99 });
            }
        });
        const globalConfigPubsub = PubSub.subscribe("workbenchGlobalConfig", () => { // 工作台全局配置
            openSidebox({
                __GlobalConfig__: true,
                sideData: props.workbenchConfig,
            }, GlobalSide);
        });
        return () => {
            PubSub.unsubscribe(autoDragPubsub); // 移除订阅
            PubSub.unsubscribe(globalConfigPubsub);
        };
    });

    useEffect(() => {
        // 左边栏或者右侧小部件编辑侧边栏任意一个出现都需要设置缩放
        setGridScale(!props.siderCollapsed || props.hasEditingSider);
    }, [props.siderCollapsed, props.hasEditingSider]);

    // useEffect(() => {
    //     // 新增后重置新增标识
    //     if (dropCompleteFlag) {
    //         setTimeout(() => { // 延迟重置，避免子组件还未渲染，这个就重置了，那么拿到的值就是重置过后的
    //             setDropCompleteFlag(false);
    //         },200)
    //     }
    // }, [dropCompleteFlag]);

    useEffect(() => {
        if (sidebox.app) { // 侧拉打开的情况，如果app有变化，及时更新侧拉的app数据
            const sideApp = props.apps.find(a => a.cardid === sidebox.app.cardid);
            if (sideApp) {
                setSidebox({
                    ...sidebox,
                    app: sideApp,
                });
            }
        }
    }, [props.apps]);

    //计算每列宽度
    const calcColWidth = useCallback(() => {
        return Math.ceil((size.width - containerPadding[0] * 2 - margin * (col - 1)) / col);
    }, [size.width]);
    const generateDOM = () => {
        // Generate layouts with properties from the layout, rather than pass the layout directly
        return layouts.map((item, i) => {
            let app = apps[i];
            return (
                <div
                    key={app.cardid}
                    className={classNames("gird-item-content", { editable }, sidebox.app && sidebox.app.cardid === app.cardid ? 'side-editing' : '')}
                    data-grid={item}
                    onClick={e => {
                        // 点击应用or部件需要选中态
                        if (sideOpened || sidebox.show) { return; }
                        editable && setSidebox({
                            ...sidebox,
                            app,
                        });
                    }}
                >
                    {renderGridItem(app, i)}
                    {/* 桌面编辑态给部件加个蒙层 */}
                    {renderWidgetMask(app)}
                </div>
            );
        });
    };

    //桌面编辑态给部件加个蒙层（除去聚合应用）
    const renderWidgetMask = app => {
        if (editable && checkApp(app).isWidget && !checkApp(app).isCompactApp) {
            return <div id={`widget-mask-${app.cardid}`} className="widget-mask"></div>;
        }
    };

    // 打开侧拉
    let sideOpened = false;
    const openSidebox = (app, side) => {
        setSidebox({ show: true, app, side });
        props.updateEditSiderStatus(true);
        sideOpened = true;
    };

    // 侧拉值改变
    const sideboxChange = (sideData, appData = {}, targetApp = sidebox.app) => {
        if (targetApp.__GlobalConfig__) {
            props.setWorkbenchConfig(sideData);
            const { app } = sidebox;
            setSidebox({
                ...sidebox,
                app: { ...app, sideData },
            });
            return;
        }
        updateAppByGroupId(groupId, targetApp.cardid, {
            ...targetApp,
            ...appData, // { width, height }
            sideData,
        });
        if (checkApp(targetApp).isQuickLaunch || checkApp(targetApp).isCommonUsedApp) { // 特殊处理-快速发起同步卡片列表到appgroup组件
            PubSub.publish("UpdateAppGroupData", {
                id: targetApp.cardid,
                data: sideData.cardList,
            });
        }
    };

    // 关闭侧拉
    const closeSidebox = () => {
        setSidebox({ show: false, app: null, side: null });
        props.updateEditSiderStatus(false);
    };

    const renderGridItem = (app, index) => {
        // 编辑
        const handleEdit = side => {
            openSidebox(app, side);
        };

        const handleDelete = () => {
            const { linkageData } = props;
            const checkObj = checkApp(app);
            if (checkObj.isCompactApp) {
                props.setAppGroupData(app.cardid, null);
            }
            props.onDeleteItem(app);
            handleRemoveItem(index);
            closeSidebox();
            // 删除部件顺便删除联动关系
            _.remove(linkageData, item => item.source_partid === app.cardid);
            linkageData.forEach(link => {
                _.remove(link.linkConfigVO, item => item.key === app.cardid);
            })
            props.setLinkageData(linkageData);
        };

        // 小部件更新侧拉数据
        const handleChange = sideData => {
            updateAppByGroupId(groupId, app.cardid, {
                ...app,
                sideData,
            });
        };

        // 显示\隐藏小部件遮罩
        const handleMaskToggle = maskShow => {
            const maskElement = document.getElementById(`widget-mask-${app.cardid}`);
            if (maskElement) {
                maskElement.style.display = maskShow ? 'block' : 'none';
            }
        };

        const handleCheckChange = checked => handleCheckboxChange(checked, index);
        //新增部件成功的回调
        const handleAddWidgetComplete = (data = {}) => {
            if (!data) { return; }
            setDropCompleteFlag(false);
            //新增外部链接把返回id赋值给cardid
            if (checkApp(app).isExternalLink && data) {
                props.updateAppProperties({
                    groupIndex: props.groupIndex,
                    id: app.cardid,
                    properties: {
                        cardid: data.pk_group_app,
                        pk_group_app: data.pk_group_app,
                    },
                });
            }
        };
        const renderDeleteBtn = () => {
            let popContent;
            //聚合应用有内容删除时弹提示
            const checkObj = checkApp(app);
            if (checkObj.isCompactApp) {
                const appGroupData = props.appGroupMap[app.cardid];
                if (appGroupData && appGroupData.length) {
                    /* 国际化处理： 删除常用应用会删除内部应用，确定删除吗？*/
                    /* 国际化处理： 删除快速发起会删除内部卡片，确定删除吗？*/
                    popContent = props.json[checkObj.isQuickLaunch ? "DesktopSetting-000080" : "DesktopSetting-000060"];
                }
            }

            // 联动关系提示
            const { linkageData } = props;
            const linkageArr = linkageData.filter(linkItem => linkItem.linkConfigVO && linkItem.linkConfigVO.length).map(item => [item.source_partid, ...item.linkConfigVO.map(ite => ite.key)]).flatten();
            if (linkageArr.includes(app.cardid)) {
                popContent = langCheck("0000PUB-000578"); // 该小部件有联动关系，确定删除吗？
            }

            if (popContent) {
                return <NCPopconfirm
                    content={popContent}
                    onClose={handleDelete}
                    placement="top"
                >
                    <i
                        fieldid={`widget_delete_${app.appcode}`}
                        className="iconfont icon-guanbi2"
                        style={{ marginRight: 0 }}
                    />
                </NCPopconfirm>;
            }
        };
        const { relateidObj } = props;
        let linkRelation = props.linkageData.reduce((r, n) => {
            if (n.linkConfigVO && n.linkConfigVO.length) {
                return { ...r, [n.source_partid]: n.linkConfigVO.map(item => item.key) }
            } else {
                return r;
            }
        }, {})

        // 获取联动关系
        const getLinkageRelationship = () => {
            const { linkageData } = props;
            const linkageRelationship = [];
            linkageData.forEach(item => {
                const color = item.color;
                if (item.source_partid === app.cardid && item.linkConfigVO && item.linkConfigVO.length) { // 主动关系
                    linkageRelationship.push({
                        linkConfig: item.linkConfigVO,
                        color,
                        type: 'to',
                    });
                }
                if (item.linkConfigVO && item.linkConfigVO.length) {
                    const passiveLink = item.linkConfigVO.find(link => link.key === app.cardid);
                    if (passiveLink) { // 被动关系
                        linkageRelationship.push({
                            key: item.source_partid,
                            value: item.name,
                            color,
                            type: 'from',
                        });
                    }
                }
            });
            return linkageRelationship;
        };

        // 渲染联动标识
        const renderLinkageIcons = () => {
            const linkageRelationship = getLinkageRelationship();
            if (!linkageRelationship.length) { return null; }
            return <LinkageIcons linkIcons={linkageRelationship}></LinkageIcons>;
        };

        return (
            <GridItem
                key={app.cardid}
                item={app}
                isChecked={app.isChecked}
                editable={editable}
                isAddComplete={dropCompleteFlag}
                isScale={isScale}
                onDelete={handleDelete}
                onCheck={handleCheckChange}
                onAddWidgetComplete={handleAddWidgetComplete}
                renderDeleteBtn={renderDeleteBtn()}
                relateidObj={relateidObj}
                linkRelation={linkRelation || []}
                renderLinkageIcons={renderLinkageIcons}
                onSideChange={handleChange}
                onMaskToggle={handleMaskToggle}
                onEdit={handleEdit}
                generateNumberName={name => { return generateNumberName(name, app.appcode, 'sideData'); }}
                themeColor={props.themeColor}
                iconType={props.iconType}
            />
        );
    };
    const handleLayoutChange = (currentLayout, allLayouts) => {
        //移动后更新布局
        if (currentLayout.length && (props.isUpdateLayout || updated)) {
            gridLayout.update(currentLayout);
            updateLayout(false);
            setMount(false);
            //重置更新标识
            setTimeout(() => {
                if (props.isUpdateLayout) {
                    props.setUpdateLayout(false);
                }
            });
        }
        //从外部把元素拖进来over状态
        // if (currentLayout.find(a => a.i === DROPPING_ELEM)) {
        //     setDragOverGrid(props.groupItem);
        // }
        // console.log("onLayoutChange", currentLayout, allLayouts, { move: props.isUpdateLayout});
    };

    //选中卡片
    const handleCheckboxChange = (checked, index) => {
        let group = cloneDeep(apps);
        const currentApp = group[index];
        currentApp.isChecked = checked;
        //勾选聚合应用把里面的应用全选
        if (checkApp(currentApp).isCompactApp) {
            setAllCompactAppChecked(currentApp.cardid, checked);
        }
        gridLayout.updateLayout(group);
    };

    //全选聚合应用内的应用
    const setAllCompactAppChecked = (compactAppId, checked) => {
        const newAppGroupData = props.appGroupMap[compactAppId].map(item => {
            item.isChecked = checked;
            return item;
        });
        props.setAppGroupData(compactAppId, newAppGroupData);
    };
    //拖放结束
    const handleDrop = (layout, item, e) => {
        const [draggingItems, isAdd] = props.onDrop ? props.onDrop(layout, true) : [];
        if (draggingItems.length === 0 || !item) { return; }
        let newItems = draggingItems.map(async (d, i) => {
            let obj = { ...d, ...{ pk_app_group: groupId } };
            const checkObj = checkApp(obj);
            if (checkObj.isCompactApp) {
                const appGroupKey = checkObj.isQuickLaunch ? await getPartsPk() : genRandomKey("1");
                obj.cardid = appGroupKey;
                obj.name = checkObj.isQuickLaunch
                    ? generateNumberName(props.json["DesktopSetting-000079"], obj.appcode, 'sideData') // 快速发起
                    : generateNumberName(props.json["DesktopSetting-000061"], obj.appcode, 'sideData'); // 常用应用
                // obj.parttype = "0"; //聚合应用保存需要的字段 0表示聚合应用 // 部件树接口已经返回了，这里不需要了，不然还得判断快速发起（parttype: 2）
                props.setAppGroupData(appGroupKey, []);
            } else if (checkObj.isExternalLink) { // 常用链接
                obj = createEmptyExternalLink(obj, {
                    cardid: isAdd ? genRandomKey('2_new') : obj.cardid,
                    name: generateNumberName(props.json["DesktopSetting-000064"], obj.appcode, 'name'),
                });
            } else {
                if (d.isNotRepeat) { // 可以重复拖拽的生成唯一的cardid
                    const pk = await getPartsPk();
                    if (pk) {
                        obj.cardid = pk;
                    }
                }
            }

            // 初始化侧拉公共配置
            const { sideData = {} } = obj;
            const initSideData = { publicData: getPublicData(obj.name, obj) };
            return {
                ...obj,
                ...{ gridx: item.x + i, gridy: Math.max(item.y - 1, 0) },
                isNew: true, // 标识新拖放的
                sideData: checkObj.isPublished ? { ...sideData } : { ...initSideData }, // 发布的部件是有数据的，不需要初始化
            };
        });
        Promise.all(newItems).then(result => {
            // 从左侧新增应用
            if (isAdd) {
                setDropCompleteFlag(true);
            }
            updateLayout(true);
            handleAddItems(result, item);
            props.setGroupDragable(true); //恢复分组拖拽
        });
    };
    //从左侧新增应用
    const handleAddItems = (items, pos) => {
        let newItems = calcDraggingItemsPos(items, pos); //将选中元素按照排列规则重新排列
        insertItems(newItems, pos, apps); //插入元素
        setTimeout(() => {
            props.setDraggingItems(null); //清空draggingItems
        });
    };

    //向指定位置添加元素并更新布局
    const insertItems = (newItems, position, groupApps) => {
        let newGroupItems = processGroupItems(newItems, position, groupApps); //重新排列分组内元素

        // 这里可能是聚合应用内部拖出去的，需要更新聚合应用的侧拉
        const { draggingItems, draggingAppGroupItem } = props;
        const { data, from } = draggingItems;
        if (
            from === DragTypes.APP_GROUP_ITEM &&
            draggingAppGroupItem.appGroupId &&
            data.length
        ) {
            const commonUsedItem = newGroupItems.find(item => item.cardid === draggingAppGroupItem.appGroupId);
            if (commonUsedItem && commonUsedItem.sideData.cardList) {
                commonUsedItem.sideData.cardList.splice(draggingAppGroupItem.index, 1);
            }
        }

        setMount(true); //重新挂载
        gridLayout.updateLayout(newGroupItems);
    };

    //删除元素
    const handleRemoveItem = index => {
        gridLayout.remove(index);
    };

    //调整大小开始
    const handleResizeStart = () => {
        props.setGroupDragable(false); //解决ie/或火狐浏览器调整大小会拖拽分组
    };

    const handleResizeMove = (newLayout, oldResizeItem, l, placeholder, e, node) => {
        let nodeRect = node.getBoundingClientRect();
        let cardContainer = document.querySelector("#ncWorkbenchHomeEditPage");
        Promise.resolve().then(() => {
            let top;
            const { relateidObj } = props;
            if (relateidObj.type === "workbench") { // 桌面设计器
                const cardRect = cardContainer.getBoundingClientRect();
                if (e.clientY < 100) {
                    top = cardContainer.scrollTop - 50;
                } else if (e.clientY > cardRect.bottom) {
                    top = cardContainer.scrollTop + 50;
                }
            } else {
                let homeFooter = document.querySelector(".nc-workbench-home-footer");
                let homeFooterRect = homeFooter.getBoundingClientRect();
                if (e.clientY > homeFooterRect.top) {
                    // 鼠标拖拽超过页脚
                    top = cardContainer.scrollTop + (nodeRect.bottom - homeFooterRect.top) + 50;
                } else if (e.clientY < 100) {
                    // 鼠标拖拽超过页头部分
                    top = cardContainer.scrollTop - 50;
                }
            }
            cardContainer.scrollTo({
                left: 0,
                top,
                behavior: "smooth",
            });
        });
    };

    //调整大小结束
    const handleResize = (layout, oldItem, newItem, placeholder, e, element) => {
        gridLayout.update(layout, newItem);
        props.setGroupDragable(true); //解决ie/或火狐浏览器调整大小会拖拽分组
    };

    //拖拽开始
    const handleDragStart = (layout, oldItem, newItem, placeholder, e, element) => {
        // const draggingItemInfo = gridLayout.findById(newItem.i);
        props.setGroupDragable(false); //解决拖拽子元素会触发分组拖拽
    };

    //拖拽中
    const handleDrag = (layout, oldItem, newItem, placeholder, e, element) => {
        const draggingItemInfo = gridLayout.findById(newItem.i);
        // setActiveGrid(element); //设置Grid高亮
        //拖拽应用可以生成聚合应用
        if (canGenerateCompact(draggingItemInfo)) {
            setCompactMode(element); //生成聚合应用模式
        }
    };

    //拖拽结束
    const handleDragEnd = (layout, oldItem, newItem, placeholder, e, element) => {
        setRemovePlaceholder(false);
        // const collideGroup = checkAppCrossGroup(element); //是否跨分组
        cancelCompactMode(); //取消聚合应用状态
        gridLayout.update(layout);
        //检测应用是否跨分组拖拽
        // if (collideGroup) {
        //     moveItemCrossGroup(element, collideGroup);
        // } else {
        //生成聚合应用
        checkCanGenerateCompactApp().then(collItem => {
            if (collItem) { generateCompactApp(newItem.i, collItem.id); }
        });
        // }
        props.setGroupDragable(true); //恢复分组拖拽
        // setDragOverGrid(null); //重置Grid高亮状态
    };

    //跨分组拖拽应用 dragElement: 拖拽元素 targetGroup: 目标分组
    const moveItemCrossGroup = (dragElement, targetGroup) => {
        const gridItemId = dragElement.id;
        let dragItem = gridLayout.findById(gridItemId);
        const moveItem2Group = () => {
            //todo 校验应用重复性
            //直接在碰撞的分组最后添加item
            dragItem.pk_app_group = targetGroup.id; //改成目标分组的pk
            dragItem.gridx = 0; //加到第一列
            dragItem.gridy = 99; //加到最后一行
            props.onAddGroupItem(dragItem, targetGroup.id);
            //拖拽到其他分组删除该item
            gridLayout.removeById(gridItemId);
        };
        //不能生成聚合应用直接添加到分组中
        if (!canGenerateCompact(dragItem)) {
            moveItem2Group();
        } else {
            //检测应用是否可以与该分组内应用生成聚合应用
            checkCrossAppCanGenerateCompact(dragElement, targetGroup).then(collideElm => {
                removeCompactHoverStyle(targetGroup);
                //有碰撞直接生成聚合应用
                if (collideElm) {
                    const targetApp = findAppByGroupId(targetGroup.id, collideElm.id);
                    //拖拽到聚合应用上
                    if (checkApp(targetApp).isCompactApp) {
                        dropItemInCompactApp(gridItemId, collideElm.id);
                    } else if (canGenerateCompact(dragItem)) {
                        //拖拽到可生成聚合应用
                        // 跨分组拖拽生成聚合应用
                        createEmptyCompactApp(targetApp).then(emptyApp => {
                            //将目标元素信息替换为空聚合信息
                            updateAppByGroupId(targetGroup.id, targetApp.cardid, emptyApp);
                            props.setDroppedAppGroupItem(emptyApp.cardid, [targetApp, dragItem]);
                            gridLayout.removeById(gridItemId);
                        });
                    }
                } else {
                    moveItem2Group();
                }
            });
        }
    };

    //修改指定分组下的app数据 groupid:目标分组id targetAppId:目标应用id data:替换目标应用的数据
    const updateAppByGroupId = (groupid, targetAppId, data) => {
        // let groups = cloneDeep(props.groups);
        // groups = groups.map((group) => {
        //     if (group.pk_app_group === groupid) {
        //         group.apps = group.apps.map((app) => {
        //             if (app.cardid === targetAppId) {
        //                 app = data;
        //             }
        //             return app;
        //         });
        //     }
        //     return group;
        // });
        // props.updateGroupList(groups);

        /*
            1.这里直接改groups，是为了避免多个部件同时更新导致只能生效一个的情况（存在从props获取的groups还未更新便再次触发，那么结果永远保留最后一次的触发）
            2.最后执行更新的克隆是为了触发其他地方的数据监听
        */
        const { groups } = props;
        for (let i = 0; i < groups.length; i++) {
            if (groups[i].pk_app_group === groupid) {
                for (let k = 0; k < groups[i].apps.length; k++) {
                    if (groups[i].apps[k].cardid === targetAppId) {
                        groups[i].apps[k] = data;
                        break;
                    }
                }
                break;
            }
        }
        props.updateGroupList(_.cloneDeep(groups));
    };

    //检测应用是否跨分组拖拽
    const checkAppCrossGroup = dragElm => {
        const $groups = document.querySelectorAll(".grid-layout-main");
        const groupDom = [...$groups].filter(item => item.id !== groupId);
        const collisions = getCollisionItem(dragElm, groupDom);
        return collisions;
    };

    //检测应用是否可以与该分组内应用生成聚合应用
    const checkCrossAppCanGenerateCompact = (dragElement, groupEle) => {
        return new Promise((resolve, reject) => {
            const itemsDomList = getGridLayoutChildNodes(groupEle);
            collideItem = getCollisionItem(dragElement, itemsDomList);
            if (collideItem) {
                const collideInfo = findAppByGroupId(groupEle.id, collideItem.id);
                //可生成聚合应用
                if (canGenerateCompact(collideInfo) || checkApp(collideInfo).isCompactApp) {
                    resolve(collideItem);
                } else {
                    reject();
                }
            } else {
                resolve();
            }
        });
    };

    //给聚合应用加hover样式 itemInfo:要加hover样式的item数据
    const setCompactHoverStyle = itemInfo => {
        checkCanGenerateCompactApp(itemInfo).then(collItem => {
            if (collItem) {
                removeCompactHoverStyle(collItem.parentNode); //先清除hover样式
                if (collItem) { collItem.classList.add("compose-hover"); }
            } else {
                cancelCompactMode(); //取消聚合应用状态
            }
        });
    };

    //清除聚合应用hover样式
    const removeCompactHoverStyle = container => {
        let nodeList = getGridLayoutChildNodes(container);
        nodeList.forEach(node => node.classList.remove("compose-hover"));
    };

    //检测是否有元素碰撞 domList:检测的nodeList element:检测碰撞的元素dom
    const getCollisionItem = (element, nodeList) => {
        const collisions = getAllCollisions(nodeList, element);
        return collisions[0]; //碰撞的第一个元素
    };

    //找到指定分组下的app数据
    const findAppByGroupId = (groupId, appId) => {
        const { groups } = props;
        const targetGroup = groups.find(g => g.pk_app_group === groupId);
        if (targetGroup) {
            return targetGroup.apps.find(item => item.cardid === appId);
        }
    };

    //获取GridLayout内的item node
    const getGridLayoutChildNodes = container => {
        return container ? [...container.childNodes] : [...gridRef.current.childNodes];
    };

    //设置聚合应用模式 dragElement：拖拽元素dom dragItem：拖拽元素
    const setCompactMode = dragElement => {
        let itemsDomList = getGridLayoutChildNodes();
        collideItem = getCollisionItem(dragElement, itemsDomList); //碰撞的第一个元素
        const collideGroup = checkAppCrossGroup(dragElement); //是否跨分组
        //检测应用是否跨分组拖拽
        if (collideGroup) {
            checkCrossAppCanGenerateCompact(dragElement, collideGroup).then(collideElm => {
                if (collideElm) {
                    const collideInfo = findAppByGroupId(collideGroup.id, collideElm.id);
                    setCompactHoverStyle(collideInfo); //给聚合应用加hover样式
                } else {
                    removeCompactHoverStyle(collideGroup);
                }
            });
        } else {
            setCompactHoverStyle(); //给聚合应用加hover样式
        }
    };

    //取消聚合应用
    const cancelCompactMode = () => {
        removeCompactHoverStyle();
    };

    //创建空的聚合应用 targetApp: 放置的app targetGroupId: targetApp所在分组，默认当前分组
    const createEmptyCompactApp = (targetApp, targetGroupId = groupId) => {
        const name = generateNumberName(props.json["DesktopSetting-000061"], PUB_WIDGET_APPCODES.commonUsedApp, "sideData"); //常用应用
        return new Promise(resolve => {
            //新增空聚合应用
            const appGroupKey = genRandomKey();
            const emptyObj = {
                appcode: PUB_WIDGET_APPCODES.commonUsedApp,
                cardid: appGroupKey,
                width: COMPACT_APP_DEFAULT_SIZE.width,
                height: COMPACT_APP_DEFAULT_SIZE.height,
                name,
                sideData: { publicData: getPublicData(name) },
                pk_app_group: targetGroupId,
                apptype: "2",
                isShadow: false,
                isChecked: false,
                children: [], //聚合应用需要
                parttype: "0", //聚合应用0
                isNotRepeat: true,
                gridx: targetApp.gridx,
                gridy: targetApp.gridy,
                isNew: true, // 标识新拖放的
                // iscommon_configuration:true, // 是否启用侧拉公共部分
            };
            props.setAppGroupData(appGroupKey, []);
            resolve(emptyObj);
        });
    };

    /*
        生成带数字的应用名称
        @params
        nameNation: 名称
        appcode: 应用编码,
        nameType: 名称类型
        
        名称存储位置不同，结构不同
        sideData 名字是以多语形式存储在侧拉的 sideData: { name: { name2: {value} } }
        name 同级平铺
    */
    const generateNumberName = (nameNation, appcode, nameType = 'name') => {
        const allApps = props.groups.map(item => item.apps);
        const sameCodeApps = _.flatten(allApps).filter(item => item.appcode === appcode);
        const nameNumber = genNameNum({
            nameNation,
            data: sameCodeApps,
            condition: (a, num) => (nameType === 'sideData' ? getCurrentLangText('name', a.sideData) : a[nameType]) === `${nameNation}${num}`,
        });
        return `${nameNation}${nameNumber}`;
    };
    // 两个应用拖拽生成聚合应用 dragAppId:拖拽元素cardid targetId：放置元素cardid
    const generateCompactApp = (dragAppId, targetId) => {
        const dragApp = gridLayout.findById(dragAppId);
        const targetApp = gridLayout.findById(targetId);
        //判断targetApp是否聚合应用
        if (checkApp(targetApp).isCompactApp) {
            dropItemInCompactApp(dragAppId, targetId);
        } else {
            //先删除dragApp
            gridLayout.removeById(dragAppId);
            //创建空聚合应用emptyGroupApp
            createEmptyCompactApp(targetApp).then(emptyApp => {
                //将目标元素信息替换为空聚合信息
                props.updateAppProperties({
                    groupIndex: props.groupIndex,
                    id: targetApp.cardid,
                    properties: emptyApp,
                    replace: true,
                });
                //等空聚合应用创建完成后添加dragApp和targetApp到emptyGroupApp中
                props.setDroppedAppGroupItem(emptyApp.cardid, [targetApp, dragApp]);
            });
        }
    };

    //元素拖到聚合应用里
    const dropItemInCompactApp = (dragAppId, targetId) => {
        const targetApp = gridLayout.findById(targetId);
        if (checkApp(targetApp).isQuickLaunch) { // 快速发起不允许放置
            return;
        }

        const dragApp = gridLayout.findById(dragAppId);
        //添加dragApp到targetApp中
        props.setDroppedAppGroupItem(targetId, [dragApp], appGroupId => {
            //添加成功删除dragApp
            gridLayout.removeById(dragAppId, appGroupId);
        });
    };

    //检测是否可以生成聚合应用
    const checkCanGenerateCompactApp = itemInfo => {
        return new Promise((resolve, reject) => {
            if (collideItem) {
                const collideItemInfo = itemInfo || gridLayout.findById(collideItem.id);
                //应用和聚合应用可生成聚合应用
                if (canGenerateCompact(collideItemInfo) || checkApp(collideItemInfo).isCommonUsedApp) {
                    //应用拖到聚合应用上清除placeholder
                    if (!removePlaceholder && checkApp(collideItemInfo).isCommonUsedApp) {
                        setRemovePlaceholder(true);
                        PubSub.publish("onRemoveGridLayoutPlaceholder"); //清除GridLayout的placeholder
                    }
                    resolve(collideItem);
                } else {
                    reject();
                }
            } else {
                removePlaceholder && setRemovePlaceholder(false); // 恢复
            }
            resolve();
        });
    };

    //检测拖拽元素是否可生成聚合应用
    const canGenerateCompact = data => {
        return checkApp(data).isAppOrLink;
    };

    // 设置缩放比例
    const setGridScale = scaleFlag => {
        const rowtHeight = getGridRowHeight(margin);
        const scale = getScale().narrow;
        setScale(scaleFlag);
        if (scaleFlag) {
            setRowHeight(rowtHeight * scale);
        } else {
            setRowHeight(rowtHeight);
        }
    };

    //把列宽存到window上给拖拽预览使用
    const setDragPreviewSize = () => {
        window.workbenchGridItemSize = {
            width: calcColWidth(),
            height: rowHeight,
            margin,
        };
    };

    //拖拽元素到Grid上方
    const setDragOverGrid = dragOverGrid => {
        if (typeof props.onGridDragOver === 'function') {
            props.onGridDragOver(dragOverGrid);
        }
    };

    //移动元素经过的Grid高亮
    const setActiveGrid = element => {
        const collideGroup = checkAppCrossGroup(element); //是否跨分组
        //跨分组拖拽
        if (collideGroup) {
            const dragOverGroupItem = props.groups.find(g => g.pk_app_group === collideGroup.id);
            if (dragOverGroupItem) {
                setDragOverGrid(dragOverGroupItem);
            }
        } else {
            setDragOverGrid(props.groupItem);
        }
    };
    // console.log("GridLayout渲染了", { apps, layouts });

    return (
        size.width ? <div
            className="workbench-grid-layout-container grid"
            style={layoutContainerStyle}
        >
            <ResponsiveGridLayout
                // key={isMount ? `${groupId}-new` : groupId} //重新挂载目的使元素按照新位置重新排列，不然相同key的元素不会重新排列位置
                // 插入元素之后这里不要重新挂载，会导致所有小部件重新挂载一次，这是有问题的（智能分析的加载比较慢，很明显），目前去重新挂载没发现啥问题
                key={groupId}
                id={groupId}
                className="grid-layout-main"
                width={size.width}
                layouts={{ lg: layouts }}
                breakpoints={{ lg: 1200 }}
                cols={{ lg: col }}
                isDraggable={editable}
                isResizable={editable}
                isDroppable={editable && props.isDroppable}
                rowHeight={rowHeight}
                removePlaceholder={removePlaceholder}
                margin={[margin, margin]} //item间隔
                containerPadding={containerPadding} //容器间距
                // isBounded={true} //只能在容器内拖拽
                // compactType="horizontal"
                innerRef={gridRef}
                draggableHandle=".gird-item-content"
                draggableCancel=".nodrag" //不能拖动的选择器
                onLayoutChange={handleLayoutChange}
                onDrag={handleDrag}
                onDrop={handleDrop}
                onResizeStart={handleResizeStart}
                onResize={handleResizeMove}
                onResizeStop={handleResize}
                onDragStart={handleDragStart}
                onDragStop={handleDragEnd}
            // useCSSTransforms={false} // false的话从左侧应用拖拽至桌面，会疯狂抖动，true的话会有小部件canvas模糊问题，两难
            >
                {generateDOM()}
            </ResponsiveGridLayout>

            {/* 侧拉 */}
            {sidebox.show && <SideBox
                key={sidebox.app.cardid}
                relateidObj={props.relateidObj}
                appOption={sidebox.app}
                sideCom={sidebox.side}
                onChange={sideboxChange}
                onClose={closeSidebox}
                generateNumberName={name => { return generateNumberName(name, sidebox.app.appcode, 'sideData'); }}
            />}
        </div> : null
    );
}

export default connect(
    state => ({
        editable: state.gridLayoutData.editable,
        groups: state.gridLayoutData.groups,
        json: state.gridLayoutData.json,
        appGroupMap: state.gridLayoutData.appGroupMap,
        isUpdateLayout: state.gridLayoutData.isUpdateLayout,
        siderCollapsed: state.gridLayoutData.siderCollapsed,
        linkageData: state.appData.linkageData,
        hasEditingSider: state.gridLayoutData.hasEditingSider,
        draggingItems: state.gridLayoutData.draggingItems,
        draggingAppGroupItem: state.gridLayoutData.draggingAppGroupItem,
        workbenchConfig: state.gridLayoutData.workbenchConfig,
    }),
    {
        setLayouts,
        setAppGroupData,
        setDroppedAppGroupItem,
        setGroupDragable,
        updateGroupList,
        setDraggingItems,
        setUpdateLayout,
        updateEditSiderStatus,
        setWorkbenchConfig,
        setLinkageData,
        updateAppProperties,
    },
)(Grid);
